import { render, staticRenderFns } from "./Profiles.vue?vue&type=template&id=d4799800&scoped=true&"
import script from "./Profiles.vue?vue&type=script&lang=ts&"
export * from "./Profiles.vue?vue&type=script&lang=ts&"
import style0 from "./Profiles.vue?vue&type=style&index=0&id=d4799800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4799800",
  null
  
)

export default component.exports